<script lang="ts">
    import isPageRtl from "@app/components/IsPageRtl";

    import type { DictionaryLanguages } from "@app/services/dictionariesRecommendationService";
    import { getLanguageImmediately } from "@app/services/languages.service";

    export let changeDictionary: (event: Event) => void;
    export let dict: DictionaryLanguages;
    let isRtl = isPageRtl();
</script>

<button
    on:click={changeDictionary}
    data-l1={dict.l1}
    data-l2={dict.l2}
    class="flex items-center w-full rounded bg-white shadow border-2 hover:border-tertiary-600 border-transparent"
>
    <div
        class="flex-1 py-2 px-3 break-words half-screen"
        class:text-right={!isRtl}
        class:text-left={isRtl}
    >
        {$getLanguageImmediately(dict.l1, true).name}
        <sup class="text-gray-500 text-xs"
            >{$getLanguageImmediately(dict.l1, true).code}
        </sup>
    </div>
    <div class="w-4">-</div>
    <div
        class="flex-1 p-2 break-words half-screen"
        class:text-right={isRtl}
        class:text-left={!isRtl}
    >
        {$getLanguageImmediately(dict.l2, true).name}
        <sup class="text-gray-500 text-xs"
            >{$getLanguageImmediately(dict.l2, true).code}</sup
        >
    </div>
</button>

<style>
    .half-screen {
        width: calc(50% - 0.5rem);
    }
</style>
